import PropTypes from "prop-types";
import React from "react";
import {getDateAndDayHeader} from "./getDateAndDayHeader";
import {StoreTotalsCellContextMenu} from "../StoreTotals/Components/StoreTotalsCellContextMenu";

const StoreTotalsHeaderComponent = ({retailerId, date, storeIds, setTimestamp, className, fillWaterMark, promoWatermark}) => {
    const trigger = {
        retailerId,
        date,
        storeIds: storeIds || [],
        setTimestamp,
        header: true
    };

    return <div className={className} data-testid={'store-totals-header-component'}>
        <StoreTotalsCellContextMenu trigger={trigger}>
            {getDateAndDayHeader(date, fillWaterMark, promoWatermark)}
        </StoreTotalsCellContextMenu>
    </div>;
}

StoreTotalsHeaderComponent.propTypes = {
    retailerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    date: PropTypes.string,
    storeIds: PropTypes.arrayOf(PropTypes.number),
    setTimestamp: PropTypes.func
}

export function getHeader(retailerId, date, storeIds, setTimestamp, className, fillWatermark, promoWatermark) {
    return () => {
        return <StoreTotalsHeaderComponent
            className={className}
            date={date}
            setTimestamp={setTimestamp}
            storeIds={storeIds}
            retailerId={retailerId}
            fillWaterMark={fillWatermark}
            promoWatermark={promoWatermark}
        />;
    };
}
